import { imageType } from '@lib/proptypes';
import GridItem from '@molecules/GridItem/GridItem';
import PropTypes from 'prop-types';

function ApplicationProcessSliderItem({ item, index }) {
  const title = `${index + 1}. ${item.title}`;

  return (
    <GridItem
      key={item.id}
      title={title}
      description={item.text}
      image={item.image}
    />
  );
}

ApplicationProcessSliderItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    image: imageType,
  }),
  index: PropTypes.number,
};

export default ApplicationProcessSliderItem;
